// Google Tag Manager utilities
// GTM Container ID
export const GTM_ID = 'GTM-WJ62PJ2K';

// Initialize dataLayer if it doesn't exist
export const initializeDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

// Push event to dataLayer
export const gtmPush = (data) => {
  initializeDataLayer();
  window.dataLayer.push(data);
};

// Track page view
export const trackPageView = (url, title) => {
  gtmPush({
    event: 'page_view',
    page_title: title,
    page_location: url,
    page_path: url
  });
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  gtmPush({
    event: eventName,
    ...parameters
  });
};

// Track user registration
export const trackRegistration = (method = 'email', userId = null) => {
  gtmPush({
    event: 'sign_up',
    method: method,
    user_id: userId
  });
};

// Track course view
export const trackCourseView = (courseId, courseName, courseType) => {
  gtmPush({
    event: 'view_item',
    item_id: courseId,
    item_name: courseName,
    item_category: courseType,
    content_type: 'course'
  });
};

// Track course registration
export const trackCourseRegistration = (courseId, courseName, courseType, price = null) => {
  gtmPush({
    event: 'begin_checkout',
    item_id: courseId,
    item_name: courseName,
    item_category: courseType,
    value: price,
    currency: 'UAH',
    content_type: 'course'
  });
};

// Track form submission
export const trackFormSubmission = (formName, formType = 'contact') => {
  gtmPush({
    event: 'form_submit',
    form_name: formName,
    form_type: formType
  });
};

// Track button clicks
export const trackButtonClick = (buttonName, location, value = null) => {
  gtmPush({
    event: 'click',
    button_name: buttonName,
    button_location: location,
    value: value
  });
};

// Track navigation
export const trackNavigation = (fromPage, toPage, navigationType = 'menu') => {
  gtmPush({
    event: 'navigation',
    from_page: fromPage,
    to_page: toPage,
    navigation_type: navigationType
  });
};

// Track search
export const trackSearch = (searchTerm, resultsCount = null) => {
  gtmPush({
    event: 'search',
    search_term: searchTerm,
    search_results: resultsCount
  });
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
  gtmPush({
    event: 'scroll',
    scroll_depth: depth
  });
};

// Track time on page
export const trackTimeOnPage = (timeInSeconds, pageName) => {
  gtmPush({
    event: 'timing_complete',
    name: 'page_time',
    value: timeInSeconds,
    page_name: pageName
  });
};
